import BuildingOutlineSvgComponent from "./svg/BuildingOutlineSvgComponents";
import DollhouseHotspotsComponent from "./svg/DollhouseHotspotsComponent";
import RoutePathElements from "./svg/PathElements";
import { useStoreDollHouseMap } from "../store";
import { shallow } from "zustand/shallow";
// import BaseMapAriaLevel1 from "../assets/images/maps/v8/DolHse_L1.jpg";
// import BaseMapAriaLevel2 from "../assets/images/maps/v8/DolHse_Aria_L2.jpg";

// import DlHse_RO_Aria_L2 from "../assets/images/maps/v5/base_map_level_2.webp";
// import cosmo_level_1 from "../assets/images/maps/v8/TC_Lvl_01.png";
// import cosmo_level_2 from "../assets/images/maps/v8/TC_Lvl_02.png";
// import cosmo_level_3 from "../assets/images/maps/v8/TC_Lvl_03.png";
// import cosmo_level_4 from "../assets/images/maps/v8/TC_Lvl_04.png";

import bagio_logo from "../assets/images/bagio_logo.png";
import aria_logo from "../assets/images/aria_logo.png";
import vdara_logo from "../assets/images/vdara_logo.png";
import cosmo from "../assets/images/cosmo_logo.png";
import park_mgm_logo from "../assets/images/park_mgm_logo.png";
import tmobilearena from "../assets/images/tmobilearena.png";

import { useEffect, useState } from "react";
import { __showDollHouseModal } from "./HotspotInfoModal";
import RoutePathBuildingHighlight from "./svg/RoutePathBuildingHighlight";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  ARIA_INFORMATION_LOGO,
  VDARA_INFORMATION_LOGO,
  BELLAGIO_INFORMATION_LOGO,
  PARK_MGM_INFORMATION_LOGO,
  COSMO_INFORMATION_LOGO,
  TMOBILE_INFORMATION_LOGO,
  NOMAD_INFORMATION_LOGO,
} from "../layouts/ViewerScene";

export default function SvgElement({
  routeResponse,
  dollhouseImages,
  transformComponentRef,
}) {
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      isSvgRoutePathVisibility: state.isSvgRoutePathVisibility,
    }),
    shallow
  );
  const theme = useTheme();
  let _xs = useMediaQuery(theme.breakpoints.only("xs"));
  let _sm = useMediaQuery(theme.breakpoints.only("sm"));
  const [showimages, setImages] = useState(false);
  useEffect(() => {
    if (dollhouseImages) {
      setImages(true);
      const { centerView, zoomToElement } = transformComponentRef.current;

      if (_xs || _sm) {
        let stva = setTimeout(() => {
          zoomToElement("area", 1.7);

          clearTimeout(stva);
        }, 50);
      } else {
        let stva = setTimeout(() => {
          centerView(2.9);
          clearTimeout(stva);
        }, 100);
      }
    }
  }, [dollhouseImages]);

  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      //  console.log("movinf");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsxink="http://www.w3.org/1999/xlink"
        width="6111"
        height="3665"
        viewBox="0 0 6111 3665"
        id="main-svg"
      >
        <defs>
          {/* <pattern
            id="img1"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image
              href="images/your-location.png"
              x="0"
              y="0"
              width="70"
              height="70"
            />
          </pattern> */}

          <pattern
            id="pattern-2"
            preserveAspectRatio="none"
            width="100%"
            height="100%"
            viewBox="0 0 1405 558"
          >
            <image
              width="1405"
              height="558"
              xlinkHref={BELLAGIO_INFORMATION_LOGO}
            />
          </pattern>
          <pattern
            id="pattern-5"
            preserveAspectRatio="none"
            width="100%"
            height="100%"
            viewBox="0 0 1012 638"
          >
            <image
              width="1012"
              height="638"
              xlinkHref={VDARA_INFORMATION_LOGO}
            />
          </pattern>

          <image
            id="image"
            width="163.047"
            height="108.094"
            xlinkHref={ARIA_INFORMATION_LOGO}
          />

          <pattern
            id="pattern-4"
            preserveAspectRatio="none"
            width="100%"
            height="100%"
            viewBox="0 0 1264 94"
          >
            <image
              width="1264"
              height="94"
              xlinkHref={COSMO_INFORMATION_LOGO}
            />
          </pattern>
          <pattern
            id="pattern"
            preserveAspectRatio="none"
            width="100%"
            height="100%"
            viewBox="0 0 1053 269"
          >
            <image
              width="1053"
              height="269"
              xlinkHref={PARK_MGM_INFORMATION_LOGO}
            />
          </pattern>
          <pattern
            id="pattern-3"
            preserveAspectRatio="none"
            width="100%"
            height="100%"
            viewBox="0 0 971 109"
          >
            <image
              width="971"
              height="109"
              xlinkHref={TMOBILE_INFORMATION_LOGO}
            />
          </pattern>

          {/* <filter id="Union_2-8" x="1803.396" y="691.634" width="385.149" height="241.995" filterUnits="userSpaceOnUse">
            <feOffset dx="2" dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3" result="blur-8"/>
            <feFlood flood-opacity="0.333"/>
            <feComposite operator="in" in2="blur-8"/>
          </filter>

          <filter id="Union_2" x="2142.748" y="1198.825" width="385.149" height="241.995" filterUnits="userSpaceOnUse">
            <feOffset dx="2" dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="3" result="blur"/>
            <feFlood flood-opacity="0.333"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
          </filter> */}
        </defs>

        <g
          id="Group_1"
          data-name="Group 1"
          clipPath="url(#clip-DolHse_L1_Final_Rajesh)"
        >
          {showimages && (
            <>
              <image
                className="base_img active-base-img"
                width="100%"
                height="100%"
                xlinkHref={dollhouseImages[0].src}
                onMouseEnter={handleMousEnter}
              />
              <image
                className="base_img"
                width="100%"
                height="100%"
                xlinkHref={dollhouseImages[1].src}
                onMouseEnter={handleMousEnter}
              />

              <image
                className="base_img"
                width="100%"
                height="100%"
                xlinkHref={dollhouseImages[2].src}
                onMouseEnter={handleMousEnter}
              />

              <image
                className="base_img active-base-img"
                width="100%"
                height="100%"
                xlinkHref={dollhouseImages[3].src}
                onMouseEnter={handleMousEnter}
              />
              <image
                className="base_img"
                width="100%"
                height="100%"
                xlinkHref={dollhouseImages[4].src}
                onMouseEnter={handleMousEnter}
              />

              <image
                className="base_img"
                width="100%"
                height="100%"
                xlinkHref={dollhouseImages[5].src}
                onMouseEnter={handleMousEnter}
              />
            </>
          )}

          <BuildingOutlineSvgComponent />
          <RoutePathBuildingHighlight />

          {dollhouseStore.isSvgRoutePathVisibility &&
          dollhouseStore.isSvgRoutePathVisibility ? (
            <RoutePathElements routeResponse={routeResponse} />
          ) : (
            <></>
          )}

          <DollhouseHotspotsComponent />
        </g>
      </svg>
    </>
  );
}
